import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import comprobanteService from "../../services/comprobanteService";
import * as serieService from "../../services/serieService";
import { setData } from "../../redux/receiptSlice";
import { Grid, Card, CardContent, Snackbar, Alert, TextField, Button } from '@mui/material';
import { Print as IconPrint } from "@mui/icons-material";
import Comprobante from '../../components/Receipt'
import ReceiptDetail from '../../components/ReceiptDetail'
import ReceiptPayment from '../../components/ReceiptPayment'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsComprobante } from '../../redux/receiptSlice';
// import ComprobanteSchedule from '../../components/ComprobanteSchedule'
// import ComprobanteTherapist from '../../components/ComprobanteTherapist'
// import ComprobanteMember from '../../components/ComprobanteMember'
// import { setEntity as setComprobanteSchedule, activeValidations as activeComprobanteSchedule } from '../../redux/receiptScheduleSlice';
// import { setEntity as setComprobanteTherapist, activeValidations as activeComprobanteTherapist } from '../../redux/receiptTherapistSlice';
// import { setEntity as setComprobanteMember, activeValidations as activeComprobanteMember } from '../../redux/receiptMemberSlice';

// Catalogo 143 = Estados de Pago del comprobante.
export const ESTADO_PAGO_PENDIENTE = 144;
export const ESTADO_PAGO_CANCELADO = 145;

const Edit = (props) => {
   const receipt = useSelector((state) => state.receipt["Normal"]?.entity);
   const listEstadoPago = useSelector((state) => state.receipt["Normal"]?.listEstadoPago);
//    const receiptSchedule = useSelector((state) => state.receiptSchedule.entity);
//    const receiptTherapist = useSelector((state) => state.receiptTherapist.entity);
//    const receiptMember = useSelector((state) => state.receiptMember.entity);
   const receiptValidation = useSelector((state) => state.receipt["Normal"]?.validationMessage);
//    const receiptScheduleValidation = useSelector((state) => state.receiptSchedule.validationMessage);
//    const receiptTherapistValidation = useSelector((state) => state.receiptTherapist.validationMessage);
//    const receiptMemberValidation = useSelector((state) => state.receiptMember.validationMessage);

//    const defaultComprobanteSchedule = useSelector((state) => state.receiptSchedule.defaultEntity)
//    const defaultComprobanteTherapist = useSelector((state) => state.receiptTherapist.defaultEntity)
//    const defaultComprobanteMember = useSelector((state) => state.receiptMember.defaultEntity)
  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const [receiptDetails, setReceiptDetails] = useState([]);
  const [receiptPayments, setReceiptPayments] = useState([]);
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const { isReadOnly, setIsReadOnly } = useMantenimiento("comprobante");

  // El saldo descuenta los pagos registrados del comprobante y el estado de
  // pago se deduce de ese saldo: cancelado cuando ya no hay saldo.
  useEffect(() => {
    const total = (receiptDetails || []).reduce((sum, item) => sum + (parseFloat(item.subTotal) || 0), 0);
    const pagado = (receiptPayments || []).reduce((sum, item) => sum + (parseFloat(item.monto) || 0), 0);
    const saldo = Math.max(total - pagado, 0);

    dispatch(setData({sliceKey: "Normal", name: "montoTotal", value: total}));
    dispatch(setData({sliceKey: "Normal", name: "montoSaldo", value: saldo}));
    dispatch(setData({sliceKey: "Normal", name: "idEstadoPago", value: saldo <= 0 && total > 0 ? ESTADO_PAGO_CANCELADO : ESTADO_PAGO_PENDIENTE}));
  }, [receiptDetails, receiptPayments]);

  // Con el comprobante ya guardado y con pagos no se edita nada: los datos y
  // el detalle quedan en solo lectura y los pagos se anulan o se agregan desde
  // la opcion de registrar pago.
  const esComprobanteNuevo = params.id == 0;
  const comprobanteConPagos = !esComprobanteNuevo && (receiptPayments || []).length > 0;
  const soloLecturaComprobante = isReadOnly || comprobanteConPagos;

  // El estado de pago se muestra en solo lectura y se deduce del saldo.
  const ESTADO_PAGO_DESCRIPCION = {
    [ESTADO_PAGO_PENDIENTE]: "Pendiente",
    [ESTADO_PAGO_CANCELADO]: "Cancelado",
    146: "Anulado",
  };
  const estadoPagoDescripcion = (listEstadoPago || [])
    .find((row) => row.id == receipt?.idEstadoPago)?.descripcion
    || ESTADO_PAGO_DESCRIPCION[receipt?.idEstadoPago]
    || "";

  const postEntity = async () => {
    var dataPost = {
      ...receipt,
      comprobanteDetalle: receiptDetails,
      comprobantePago: receiptPayments
    //   , terapiaHorario: receiptSchedule, terapiaTerapeuta: receiptTherapist, terapiaParticipante: receiptMember
    }

    // Si el usuario dejo el numero vacio se genera el siguiente de la serie.
    if (params.id == 0 && (dataPost.numero == null || dataPost.numero === "" || dataPost.numero === 0)) {
      const series = await serieService.getsSerie()
        .catch((err) => { console.log("Err: ", err) });

      const serie = series?.find((row) => row.codigo === dataPost.serie);

      if (serie) {
        dataPost.numero = await serieService.obtenerSiguienteNumero(serie.id)
          .catch((err) => { console.log("Err: ", err) });
      }
    }

    if (dataPost.numero != null && dataPost.numero !== "") {
      dataPost.numero = parseInt(dataPost.numero);
    }

    var ValidationMessages = receiptValidation || []

    console.log(dataPost)
    console.log(ValidationMessages)

    if (ValidationMessages.length > 0) {
      dispatch(activeValidationsComprobante({sliceKey: "Normal"}));
    //   dispatch(activeComprobanteSchedule());
    //   dispatch(activeComprobanteTherapist());
    //   dispatch(activeComprobanteMember());

      setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
      setOpenMessage(true);
    }
    else {
      await comprobanteService.addUpdateComprobanteWithDetails(dataPost)
        .then(response => {
          const idGuardado = parseInt(response.data.data);

          // Se refleja en la pantalla lo que quedo guardado: el numero generado
          // y los montos, y se navega al comprobante ya registrado.
          dispatch(setData({sliceKey: "Normal", name: "numero", value: dataPost.numero}));
          dispatch(setData({sliceKey: "Normal", name: "montoTotal", value: dataPost.montoTotal}));
          dispatch(setData({sliceKey: "Normal", name: "montoSaldo", value: dataPost.montoSaldo}));

          setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
          setOpenMessage(true);
          setIsReadOnly(true);

          if (params.id == 0 && idGuardado > 0) {
            navigate("/receipt/edit/" + idGuardado);
          }

        //   if (receipt.id > 0){
        //     api.get("/Comprobante/GetsComprobanteHorarioView?idComprobante=" + receipt.id)
        //     .then(response => {
        //       if (response.data.data === null || response.data.data.length === 0)
        //         dispatch(setComprobanteSchedule(defaultComprobanteSchedule));
        //       else
        //         dispatch(setComprobanteSchedule(response.data.data));
        //     })
        //     .catch((err) => {
        //       console.log("Err: ", err);
        //     });

        //     api.get("/Comprobante/GetsComprobanteTerapeutaView?idComprobante=" + receipt.id)
        //     .then(response => {
        //       if (response.data.data === null || response.data.data.length === 0)
        //         dispatch(setComprobanteTherapist(defaultComprobanteTherapist));
        //       else
        //         dispatch(setComprobanteTherapist(response.data.data));
        //     })
        //     .catch((err) => {
        //       console.log("Err: ", err);
        //     });
             
        //     api.get("/Comprobante/GetsComprobanteParticipanteView?idComprobante=" + receipt.id)
        //     .then(response => {
        //       if (response.data.data === null || response.data.data.length === 0)
        //         dispatch(setComprobanteMember(defaultComprobanteMember));
        //       else
        //         dispatch(setComprobanteMember(response.data.data));
        //     })
        //     .catch((err) => {
        //       console.log("Err: ", err);
        //     });
        //   }
        })
        .catch(error => {
          setPropsMessage({ severity: "error", message: "Hubo un error" })
          setOpenMessage(true);
        });
    }
  }

  return (
    <div>
      <MantenimientoForm
        title={(params.id == 0 ? "Nuevo" : "Editar") + " Comprobante"}
        backTo={"/receipt"}
        onSave={postEntity}
        disabled={soloLecturaComprobante}
      >
      <Grid container spacing={1} sx={{
        "& .MuiGrid-root>.MuiGrid-item": {
          paddingTop: "8px"
        },
      }}>
        <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
          <Button
            size="small"
            startIcon={<IconPrint />}
            onClick={() => navigate("/receipt/print/" + params.id)}
            disabled={params.id == 0}
          >
            Imprimir
          </Button>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Card >
            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
              <Comprobante sliceKey={"Normal"} isReadOnly={soloLecturaComprobante} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Card>
            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
              <ReceiptDetail sliceKey={"Normal"} setDetails={setReceiptDetails} esNuevo={esComprobanteNuevo} isReadOnly={soloLecturaComprobante} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Card>
            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
              <ReceiptPayment sliceKey={"Normal"} setPayments={setReceiptPayments} esNuevo={esComprobanteNuevo} isReadOnly={isReadOnly || !esComprobanteNuevo} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Card>
            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
              <Grid container spacing={1} alignItems="center" sx={{ paddingTop: "12px" }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    name="observaciones"
                    label="Observaciones"
                    fullWidth
                    value={receipt?.observaciones || ""}
                    onChange={(event) => {
                      dispatch(setData({sliceKey: "Normal", name: "observaciones", value: event.target.value}))
                    }}
                    disabled={soloLecturaComprobante}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <TextField
                    disabled
                    type="number"
                    name="montoTotal"
                    label="Total"
                    inputProps={{ step: 0.01 }}
                    fullWidth
                    value={receipt?.montoTotal || 0}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <TextField
                    disabled
                    type="number"
                    name="totalPago"
                    label="Total Pago"
                    inputProps={{ step: 0.01 }}
                    fullWidth
                    value={(receiptPayments || []).reduce((sum, item) => sum + (parseFloat(item.monto) || 0), 0)}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6} sm={2}>
                  <TextField
                    disabled
                    type="number"
                    name="montoSaldo"
                    label="Saldo"
                    inputProps={{ step: 0.01 }}
                    fullWidth
                    value={receipt?.montoSaldo || 0}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              <Grid item xs={6} sm={2}>
                  <TextField
                    disabled
                    name="estadoPago"
                    label="Estado de Pago"
                    fullWidth
                    value={estadoPagoDescripcion}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        {/* <Grid item xs={12} sm={12}>
          <Card>
            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
              <ComprobanteTherapist />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
              <ComprobanteMember />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
              <ComprobanteSchedule />
            </CardContent>
          </Card>
        </Grid> */}
      </Grid>
      </MantenimientoForm>
      <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
        anchorOrigin={{vertical: "top", horizontal: "center"}}>
        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
          {propsMessage.message}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default Edit
